import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=59ce8cc3"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=59ce8cc3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ce8cc3')) {
      api.createRecord('59ce8cc3', component.options)
    } else {
      api.reload('59ce8cc3', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=59ce8cc3", function () {
      api.rerender('59ce8cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Painel/components/Dashboard.vue"
export default component.exports